
import { defineComponent } from "vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";

export default defineComponent({
  components: {
    IntegerControl,
  },
  props: {
    model: { required: true },
  },
  methods: {},
  created(){
    this.modelLocal = this.model;    
  },
  data(){
    return {
      modelLocal: null,
      weight: [{name: "cabinAxle", top: 345, left: 190},
        {name: "tractorFirstAxle", top: 345, left: 375}, 
        {name: "semitrailerFirstAxle", top: 345, left: 585}],
      distance: [{name: "tractorAxlesDistanceFirst", top: 152, left: 313, width: 40},
        {name: "tractorAxlesDistanceSecond", top: 152, left: 363, width: 40},
        {name: "tractorCabinAxlesDistance", top: 292, left: 290, width: 56},
        {name: "tractorSemitrailerAxlesDistance", top: 113, left: 450, width: 56}],
    };
  },
});
